import { Component, OnInit } from '@angular/core';
import { Sprema } from './sprema';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-sprema-modal-update',
  templateUrl: './sprema-modal-update.component.html'
})
export class SpremaModalUpdateComponent 
extends BaseModalUpdateComponent<Sprema> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Sprema>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }



  ngOnInit() {
  }

}
